import React from 'react';

import { ReactComponent as JavelinLogo } from 'assets/icons/logo-javelin-bounding.svg';
import { ReactComponent as AdyenLogo } from 'assets/icons/logo-adyen.svg';
import { ReactComponent as LockIcon } from 'assets/icons/lock.svg';

import { newCompany as TEXT } from 'locales/en';

const HopRedirection = ({ brand }) => {
  return (
    <div className="card py-10 md:py-24 md:px-12 relative">
      <div className="text-center">
        <p
          className="text-javelin-gray-dark text-base md:text-xl"
          dangerouslySetInnerHTML={{ __html: TEXT.submitting }}
        />
        <p className="text-sm md:text-base text-javelin-gray-light pb-1 pt-2 box-content">
          {TEXT.submitInfo}
        </p>
        <div className="py-11 border rounded border-gray-100 bg-white grid grid-flow-col items-center justify-center md:w-112 mx-auto px-4 my-12 gap-x-10">
          <brand.HopLogo className="h-6" opacity=".2" fill="#000" width="100" />
          <JavelinLogo className="w-auto h-6" />
          <AdyenLogo className="w-auto h-6" />
        </div>
        <span className="text-javelin-gray-light text-xs md:text-sm">
          <LockIcon className="h-3 w-3 mr-2 fill-current inline-block" />
          <span>{TEXT.securely}</span>
        </span>
      </div>
      <div className="absolute bottom-0 left-0 w-full h-2 md:h-4">
        <div className="h-2 md:h-4 animate-progress bg-brand-primary"></div>
      </div>
    </div>
  );
};

export default HopRedirection;
